import {FormattersTypes} from '@/services/types/formatter';
import markList from '@/views/reports/pickers/add-marks/mark-list';

export default ({ vtag, component, data, key, colors }: FormattersTypes) => {
  component.tag = 'span';

  const value = data[key] || '';
  const child = vtag('span', {domProps:{innerHTML: value}}, [])

  if (data.DT_RowStatus === 'archived' && data.DT_RowName === data[key]) {
    const icon = vtag('ui-icon',
      {
        props: {
          size: 12,
          icon: 'fas fa-trash-alt',
          color: 'var(--color-gray50)',
        },
        class: [
          'mark-in-table'
        ],
      }
    )

    return vtag('div', {}, [icon, child]);
  }

  if(data.DT_RowMark || data.DT_RowMark === 0) {
    const markData = markList.find((e) => +e.mark === +data.DT_RowMark);

    const icon = vtag('ui-icon', {
      class: [
        markData.class,
        'mark-in-table'
      ],
      props: {
        color: colors[markData.color],
        size: 12,
        icon: markData.icon,
      }
    });

    return vtag('div', {}, [icon, child]);
  }

  return component
}
